import LogRocket from 'logrocket';
import { useEffect } from 'react';
import * as Sentry from '@sentry/react';

import { useAppSelector } from 'store';
import { joinStrings } from 'utils/helpers';
import { selectAuthUser } from 'store/slices/auth';

export const useSetupUserLogs = () => {
  const user = useAppSelector(selectAuthUser);

  useEffect(() => {
    if (!user) {
      Sentry.setUser(null);
      return;
    }

    const commonUserInfo = {
      email: user.email,
      username: user.name,
    };

    Sentry.setUser({
      id: user.id,
      ...commonUserInfo,
    });

    LogRocket.identify(String(user.id), {
      ...commonUserInfo,
      role: user?.role?.name,
      features: joinStrings(user?.features || [], ', '),
    });
  }, [user?.name, user?.features, user?.id, user?.email, user?.role?.name]);
};
